/**
 * Cómo se LLAMA cada nivel en pantalla. Una sola tabla para toda la app.
 *
 * POR QUÉ EXISTE ESTE ARCHIVO
 * La etiqueta estaba copiada en cuatro sitios, y cada copia se olvidó de `director`
 * en cuanto se agregó el nivel: el desplegable y la tarjeta lo pintaban CRUDO
 * ("director"), y Team Config y Guardias —que resuelven el rol con un ternario— lo
 * mostraban como **"Promotor"**, que es peor: no parece un error, parece un dato.
 *
 * La regla del frente vuelve a aplicar: la llave interna y la palabra del negocio son
 * cosas distintas. `director` NUNCA se llama "superadmin" por dentro, porque esa
 * palabra cruza 85 puertas de plataforma (`require_superadmin`); y NUNCA se muestra
 * como "director" por fuera, porque el negocio lo llama Superadministrador.
 *
 * La fuente autoritativa es el backend: `GET /user-types/catalog` manda `base_roles`
 * con `{key, label}`. Por eso `etiquetaNivel` acepta ese catálogo y lo prefiere; esta
 * tabla es el respaldo para las pantallas que no lo cargan (Team Config, Guardias).
 */

/** Respaldo local. Debe cubrir todas las llaves de NIVELES (core/user_types.py). */
export const ETIQUETA_NIVEL = {
  director: 'Superadministrador',
  admin: 'Administrador',
  manager: 'Gerente',
  vendor: 'Vendedor',
  guard: 'Guardia',
};

/**
 * La palabra que ve el usuario para un nivel.
 *
 * @param {string} clave        la llave interna ('director', 'vendor'…)
 * @param {Array}  baseRoles    opcional: `catalogo.base_roles` del servidor, que manda
 * @returns {string} la etiqueta; si el nivel es desconocido devuelve '—', NUNCA la
 *   llave cruda: mostrar el nombre interno es una fuga de vocabulario técnico y fue
 *   exactamente el fallo que se detectó validando.
 */
export function etiquetaNivel(clave, baseRoles = null) {
  if (!clave) return '—';
  const delServidor = (baseRoles || []).find((r) => r.key === clave)?.label;
  return delServidor || ETIQUETA_NIVEL[clave] || '—';
}
